import React, {Component} from 'react';
import {Col} from 'react-bootstrap';
import Select from 'react-select'

export default class EventType extends Component {
	customStyles = {
		container: (provided) => ({
			...provided,
			color: 'black',
			fontWeight: 'bold'
		}),
		control: (provided) => ({
			...provided,
			padding: 10,
			marginBottom: 30,
			marginTop: 40,
			borderColor: 'black',
			borderStyle: 'solid',
			borderWidth: 4,
			'&:hover': {borderColor: 'black'}, // border style on hover
		}),
		singleValue: (provided) => ({
			...provided,
			color: 'black',
		}),
	}

	handleChange = value => {
		this.props.onChange("event_type", value.value);
	};

	handleBlur = () => {
		// this is going to call setFieldTouched and manually update touched.
		this.props.onBlur("event_type", true);
	};

	render() {
		return (
			<Col md="6">
				<h4 className="ui centered question-header text-center">Type of event</h4>
				<Select
					options={this.props.data}
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					styles={this.customStyles}
					name="event_type"
				/>
			</Col>
		)
	}
}
